import { render, staticRenderFns } from "./index.vue?vue&type=template&id=049d3fa5&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=049d3fa5&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d3fa5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPageBreadCrumb: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/blog/BlogPageBreadCrumb.vue').default,CmsRichText: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/cms/CmsRichText.vue').default,AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,BlogDetailPagination: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/blog/BlogDetailPagination.vue').default,BlogRecent: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/blog/BlogRecent.vue').default,BlogCategories: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/blog/BlogCategories.vue').default})
